export default __webpack_public_path__ + "d0d76494f522eb4fd950c47f9af3c998.svg";